import React from 'react';
import styled from 'styled-components';
import { P4 } from '../../../Atoms/Typo';

const Component = styled.div`
  ${P4}
  color: ${(props) => props.theme.colors.grey500};
  height: 16px;
`;

interface DashboardTitleProps {
  title: string;
}

const DashboardTitle = ({ title }: DashboardTitleProps) => {
  return <Component className="voda_dashboard_eng_title">{title}</Component>;
};

export default DashboardTitle;
